/**
 * PSTV Scroll Reveal — IntersectionObserver
 *
 * Usage: add class="pstv-reveal" to any element.
 * Optional stagger: add data-delay="100" (100/200/300/400/500ms).
 * CSS handles the actual transition (see pstv-base.css).
 *
 * Fires once per element. Respects prefers-reduced-motion via CSS.
 */
(function () {
  'use strict';

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pstv-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -48px 0px'
    }
  );

  function init() {
    var elements = document.querySelectorAll('.pstv-reveal');
    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

